import { fetchApi } from "containers/helpers";

export const getContracts = () => fetchApi('/contracts')

export const getAppointments = (isBtoB) => fetchApi(`/appointments?plateform=${isBtoB ? '0' : '1'}`)

export const paymentReceivedAPI = (contractId) => fetchApi('/contract/received/transfer/'+contractId, {
    method: 'PATCH'
})